import { Link } from "react-router-dom";
import { Mail, MapPin, Phone, MessageCircle } from "lucide-react";
import Logo from "./Logo";
import { CONTACT, useLang } from "@/lib/i18n";

const NAV = [
  { path: "/", key: "home" },
  { path: "/qui-sommes-nous", key: "about" },
  { path: "/nos-activites", key: "activities" },
  { path: "/partenariats", key: "partnerships" },
  { path: "/contact", key: "contact" },
];

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="bg-pine text-white" data-testid="footer">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 sm:px-8 md:grid-cols-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <span className="inline-flex items-center bg-white px-4 py-2.5">
            <Logo className="h-10 w-auto" />
          </span>
          </div>
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-white/70">
            {t.footer.tagline}
          </p>
          <p className="mt-5 text-[11px] uppercase tracking-[0.18em] text-white/50" data-testid="footer-siren">
            {CONTACT.siren}
          </p>
        </div>

        <div className="md:col-span-3">
          <h3 className="text-[11px] font-semibold uppercase tracking-[0.25em] text-[#9CC5B4]">
            {t.footer.navTitle}
          </h3>
          <ul className="mt-5 space-y-3">
            {NAV.map((it) => (
              <li key={it.key}>
                <Link
                  to={it.path}
                  data-testid={`footer-link-${it.key}`}
                  className="text-sm text-white/75 transition-colors duration-200 hover:text-white"
                >
                  {t.nav[it.key]}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <h3 className="text-[11px] font-semibold uppercase tracking-[0.25em] text-[#9CC5B4]">
            {t.footer.contactTitle}
          </h3>
          <ul className="mt-5 space-y-4 text-sm">
            <li>
              <a
                href={`mailto:${CONTACT.email}`}
                data-testid="footer-link-email"
                className="flex items-center gap-3 text-white/75 transition-colors duration-200 hover:text-white"
              >
                <Mail className="h-4 w-4 shrink-0 text-[#9CC5B4]" />
                {CONTACT.email}
              </a>
            </li>
            <li>
              <a
                href={CONTACT.telHref}
                data-testid="footer-link-phone"
                className="flex items-center gap-3 text-white/75 transition-colors duration-200 hover:text-white"
              >
                <Phone className="h-4 w-4 shrink-0 text-[#9CC5B4]" />
                {CONTACT.phone}
              </a>
            </li>
            <li>
              <a
                href={CONTACT.wa}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-link-whatsapp"
                className="flex items-center gap-3 text-white/75 transition-colors duration-200 hover:text-white"
              >
                <MessageCircle className="h-4 w-4 shrink-0 text-[#9CC5B4]" />
                WhatsApp {CONTACT.phone}
              </a>
            </li>
            <li className="flex items-start gap-3 text-white/75">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-[#9CC5B4]" />
              {CONTACT.address}
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-5 py-6 sm:px-8 md:flex-row">
          <p className="text-[10px] uppercase tracking-[0.18em] text-white/50">
            © {new Date().getFullYear()} Eco Mobile Solutions — {t.footer.rights}
          </p>
          <p className="text-[10px] uppercase tracking-[0.18em] text-white/50">
            {t.footer.legal}
          </p>
        </div>
      </div>
    </footer>
  );
}
